import { useSessionStorage } from "@vueuse/core";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: useSessionStorage("token", null as string | null),
    refreshToken: useSessionStorage("refreshToken", null as string | null),
    refreshing: useSessionStorage("refreshing", Boolean),
    sessionExpired: useSessionStorage("sessionExpired", Boolean),
    forcePasswordChange: useSessionStorage("forcePasswordChange", Boolean),
  }),
  actions: {
    getUserInfo() {
      const userInfo = {
        userId: "",
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        scope: "",
        entity: "",
      };
      if (this.token == null) return userInfo;
      let base64Url = this.token.split(".")[1];
      let base64 = base64Url.replace("-", "+").replace("_", "/");
      let data = JSON.parse(atob(base64));
      userInfo.userId = data.user;
      userInfo.username = data.username;
      userInfo.firstName = data.given_name;
      userInfo.lastName = data.surname;
      userInfo.email = data.email;
      userInfo.scope = data.scope;
      userInfo.entity = data.entity;
      return userInfo;
    },
    clearSession() {
      this.token = null;
      this.refreshToken = null;
      this.refreshing = false;
      this.sessionExpired = false;
    },
    expireSession() {
      this.clearSession();
      this.sessionExpired = true;
    },
    hasAuth() {
      return this.token != null;
    },
    isSessionExpired() {
      return this.sessionExpired;
    },
  },
});
